export default __webpack_public_path__ + "static/media/fast_light.601c3840.svg";